import Icon from "../../Icon/Icon";
import {INPUT_ICON_ACCESSIBILITY_TEXT} from "../utils";
import React from "react";

export function RenderLoadingIcon(props) {
  const {intl} = props;
  return <div className={"InputField__icon_wrapper"}>
    <Icon
      className="InputField__icon_svg"
      desc={intl.formatMessage(INPUT_ICON_ACCESSIBILITY_TEXT.loadingSpinnerDesc)}
      id="InputField__loadingSpinner"
      name="spinner"
      title={intl.formatMessage(INPUT_ICON_ACCESSIBILITY_TEXT.title)}
      styles={{width: "12px", height: "12px", fill: "#677383"}}
    />
  </div>;
}
